import { type MouseEvent, memo } from 'react';

import { Close } from '@air/next-icons';
import { IconButton } from '@air/primitive-icon-button';
import { cn } from '@air/utils-tailwind';

import { preventDefaultMouseEvent } from '~/utils/ClickUtils';

type InputClearButtonProps = {
  isVisible: boolean;
  isFlex?: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  'data-testid'?: string;
};

export const InputClearButton = memo(
  ({ isVisible, isFlex = false, onClick, 'data-testid': testId }: InputClearButtonProps) => {
    return (
      <div
        className={cn(
          'flex h-full w-6 flex-col items-center justify-center',
          isFlex ? undefined : 'absolute top-0 right-1.5',
          isVisible ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0',
        )}
      >
        <IconButton
          label="Clear"
          data-testid={testId}
          appearance="ghost"
          color="grey"
          icon={Close}
          size="small"
          onMouseDown={preventDefaultMouseEvent}
          onClick={onClick}
        />
      </div>
    );
  },
);

InputClearButton.displayName = 'InputClearButton';
